import React, { useRef } from "react";
import Tooltip from "rc-tooltip";
import iconDownload from "assets/IconDownload.svg?url";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PropTypes from "prop-types";
import useClickOutside from "js/utils/outsideClickUtils";

const ConfirmScreenshotPopup = ({ document, tooltipOpen, filename, onAccept, children, onPopupVisibleChange }) => {
	const tooltipRef = useRef(null);
	const childRef = useRef(null);

	// handle clicks outside of the tooltip / children of the popup (i.e. the screenshot button)
	useClickOutside([tooltipRef, childRef], () => {
		onPopupVisibleChange(false);
	});

	const acceptButtonPressed = () => {
		onPopupVisibleChange(false);
		onAccept();
	};

	return (
		<Tooltip
			id="download-screenshot-confirmation"
			visible={tooltipOpen}
			placement="top"
			overlayClassName={"P2PDisplayModal_downloadScreenshotPopup"}
			align={{ offset: [0, -16] }}
			arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
			overlay={
				<div ref={tooltipRef}>
					<span className="P2PDisplayModal_downloadScreenshotAcceptText">
						Files will be downloaded to your computer and must be handled in accordance with your institution&apos;s privacy policies.
					</span>
					<br />
					{document && (
						<PDFDownloadLink document={document} fileName={filename}>
							<button
								onClick={acceptButtonPressed}
								className="button-callToAction--normal Classroom_start--wide P2PDisplayModal_button P2PDisplayModal_downloadScreenshotAcceptButton"
							>
								<img src={iconDownload} className="P2PDisplayModal_buttonIcon" alt="Take screenshot" />
								Accept and download screenshot
							</button>
						</PDFDownloadLink>
					)}
				</div>
			}
		>
			<div ref={childRef}>{children}</div>
		</Tooltip>
	);
};

ConfirmScreenshotPopup.propTypes = {
	tooltipOpen: PropTypes.bool,
	children: PropTypes.object,
	document: PropTypes.object,
	filename: PropTypes.string,
	onAccept: PropTypes.func.isRequired,
	onPopupVisibleChange: PropTypes.func.isRequired,
};

export default ConfirmScreenshotPopup;
